var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12 pl-0 pr-0 yuanjiao baise p-3 d-flex justify-content-between align-items-center parent mb-4 sjiduanbju"},[(_vm.show==0)?_c('ptyh'):_vm._e(),(_vm.show==1)?_c('qyyh'):_vm._e(),(_vm.show==2)?_c('tdzzxx'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }